// extracted by mini-css-extract-plugin
export default {"tableContainer":"FrontendDataTable_tableContainer__ALHYV","tableScroll":"FrontendDataTable_tableScroll__EB9EL","table":"FrontendDataTable_table__UZj7V"};